<template>
  <MainLayout>
    <Head title="Users" />
    <template v-slot:header>Users</template>

    <div class="mb-4">
      <ButtonGroup>
        <Link :href="$route('roles.index')"
              v-if="$can('roles.read')">
          <UserGroupIcon class="w-4 h-4 mr-2" /> Roles
        </Link>
        <Link :href="$route('users.create')" v-if="$can('users.write')">Add User</Link>
      </ButtonGroup>
    </div>

    <DataTable :pagination="users" class="mt-4">
      <template v-slot:header>
        <th scope="col" class="">
          Name
        </th>
        <th scope="col">
          Email
        </th>
        <th scope="col">
          Role
        </th>
        <th scope="col">
          <span class="sr-only">Edit</span>
        </th>
      </template>

      <tr v-for="user in users.data" :key="user.id">
        <td>{{ user.name }}</td>
        <td>{{ user.email }}</td>
        <td>{{ user.roles[0].name }}</td>
        <td>
          <div class="flex gap-2 place-content-end">
            <button type="button"
                    class="text-red-600 hover:text-red-900"
                    v-if="$can('users.write')"
                    @click="deleteUser(user)">Delete</button>
            <Link :href="$route('users.edit', [user.id])" class="text-indigo-600 hover:text-indigo-900">Edit</Link>
          </div>
        </td>
      </tr>
    </DataTable>
  </MainLayout>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import PageComponent from '@/pages/page-component'
import DataTable from '@/components/data-table.vue'
import { UserGroupIcon } from '@heroicons/vue/outline'
import UsesPermissions from '@/mixins/uses-permissions'
import { Inertia } from '@inertiajs/inertia'

export default {
  mixins: [
    PageComponent,
    UsesPermissions,
  ],

  components: {
    UserGroupIcon,
    DataTable,
    Link,
  },

  props: {
    users: Object,
  },

  methods: {
    deleteUser(user) {
      if (confirm('Are you sure?')) {
        Inertia.delete(this.$route('users.destroy', [user.id]))
      }
    }
  }
}
</script>
